import script from "./practice-assistant-form-re-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./practice-assistant-form-re-dialog.vue?vue&type=script&setup=true&lang=js"

import "./practice-assistant-form-re-dialog.vue?vue&type=style&index=0&id=fc0a4588&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc0a4588"]])

export default __exports__